import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import ModifiersEditor from '../ModifiersEditor'

export class MathEditor extends Component {
  constructor ({ variable: { args } }) {
    super()
    this.state = {
      expression: args[0] || ''
    }
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    if (nextProps.report === true && report === false) {
      save(variableName, [this.state.expression])
    }
  }

  componentDidUpdate (_, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  handleExpressionChange (value) {  
    this.setState({
      expression: value
    })
  }

  render () {
    const { modifiers, instance, instanceModifiers } = this.props

    let instanceOption = null
    if (instance) {
      instanceOption = <ModifiersEditor instanceModifiers={instanceModifiers} isInstance />
    }

    return (
      <div className={css.margin}>
        <div className={css.input}>
          <label>Enter an expression</label>
          <input className={css.option} onChange={ (evt) => { this.handleExpressionChange(evt.target.value) } } value={this.state.expression} />
        </div>
        <ModifiersEditor modifiers={modifiers} />
        {instanceOption}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(MathEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/MathEditor/index.js